import { parsePhoneNumberFromString } from "libphonenumber-js";
export function formatPhoneNumber(phoneNumber, country, format = "E.164", checkValidity = "none") {
    try {
        const targetRegion = (country && country.length > 0 ? country : "US");
        const parsed = parsePhoneNumberFromString(phoneNumber, targetRegion);
        if (!parsed)
            return null;
        if (checkValidity === "valid-region" && (!parsed.isValid() || parsed.country !== targetRegion)) {
            return null;
        }
        if (checkValidity === "valid" && !parsed.isValid()) {
            return null;
        }
        if (checkValidity === "possible" && !parsed.isPossible()) {
            return null;
        }
        return parsed.format(format);
    }
    catch {
        return null;
    }
}
export function formatUSOnlyPhoneNumber(phoneNumber) {
    return formatPhoneNumber(phoneNumber, "US", "E.164", "valid-region");
}
export function formatUSPhoneInputAsTyped(value) {
    let digits = value.replace(/\D/g, "");
    if (digits.length === 11 && digits.startsWith("1")) {
        digits = digits.slice(1);
    }
    digits = digits.slice(0, 10);
    if (digits.length <= 3) {
        return digits;
    }
    if (digits.length <= 6) {
        return `${digits.slice(0, 3)}-${digits.slice(3)}`;
    }
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
}
export function formatUSPhoneForDisplay(phoneNumber) {
    const usNumber = phoneNumber.match(/^\+?1?(\d{3})(\d{3})(\d{4})$/);
    return usNumber ? `${usNumber[1]}-${usNumber[2]}-${usNumber[3]}` : phoneNumber;
}
